import { Pipe, Injectable, PipeTransform } from '@angular/core';
import { MODO_DESCONECTADO } from "../config/url.servicio"

@Pipe({
  name: 'filtroProductos'
})
@Injectable()
export class filtroProductos implements PipeTransform {

  transform(productos, grupoId) {
    // si el filtro no esta definido retorna todos los productos
    if( !grupoId || grupoId == 0 || grupoId == '') {
      return productos
    }
    if(MODO_DESCONECTADO){
      // filtrar los productos con el grupoId

      let productosCoincidencias = productos.filter( item => item.nombreGrupoProducto === grupoId)
      if (productosCoincidencias.length == 0){

        productosCoincidencias = productos.filter( item => item.productosPorGruposId === grupoId)
      }

      return productosCoincidencias;
    }else{
      // filtrar los productos con el grupoId
      let productosCoincidencias = productos.filter( item => item.gruposProductosId === grupoId)
      return productosCoincidencias;
    }

  }
}



// WEBPACK FOOTER //
// ./src/pipes/filtroProductos.ts